import { Flex, themeColors } from '@hg/stylizator/utils'
import classNames from 'classnames'
import * as React from 'react'
import styled from 'styled-components'

import { MOBILE_HEADER_MIN_WIDTH } from 'app/components/Header/model'

interface IProps {
  opened: boolean
  onClick: () => void
}

const Burger: React.FC<IProps> = (props) => {
  return (
    <Flex align="center" justify="center">
      <MobileNavView onClick={props.onClick}>
        <MenuIcon className={classNames({ active: props.opened })} />
      </MobileNavView>
    </Flex>
  )
}

const MobileNavView = styled.button`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-width: 40px;
  height: 40px;
  padding: 4px;
  border: none;
  background-color: transparent;

  @media (min-width: ${MOBILE_HEADER_MIN_WIDTH + 1}px) {
    display: none;
  }
`

const MenuIcon = styled.div`
  position: relative;
  border-radius: 2px;
  width: 20px;
  height: 2px;
  background-color: ${themeColors.gray['60']};
  transition-duration: 0.3s;
  &.active {
    background-color: transparent;

    &:before {
      position: absolute;
      transform: translateY(7px) rotate(45deg);
    }
    &:after {
      transform: translateY(-7px) rotate(-45deg);
    }
  }
  &::after,
  &::before {
    border-radius: 2px;
    content: '';
    position: absolute;
    left: 0;
    width: inherit;
    height: inherit;
    transition-duration: inherit;
    background-color: ${themeColors.gray['60']};
  }
  &::before {
    bottom: 7px;
  }
  &::after {
    top: 7px;
  }
`

export default Burger
